import React, { Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import RoleHelper from '../../../../../RoleHelper';
import { CaseAction, CaseSettings, CaseActionStatus } from '../../../../../domain/case/CaseDomains';
import MessageUtil from '../../../../../util/MessageUtil';
import { AnimatedButton } from '@trlogic/ui-pack';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { ConfigurationState } from '../../../../../redux/reducers/ConfigurationReducer';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationActionCreatorComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { name, status } = this.state;

    return (
      <div className={'w-full flex flex-col lg:flex-row justify-around items-center mt-5 mb-5 gap-y-5 gap-x-5'}>
        <div className={'w-full flex'}>
          <FormicaSearchSelectBox
            onChange={(e: FormicaSelectBoxItem) => this.onChangeName(e)}
            value={name}
            name={'Action'}
            label={LanguageUtil.get({ id: 'common.label.actionName', defaultMessage: 'Action Name' })}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.actionName', defaultMessage: 'Action Name' })}
            type={'text'}
            options={this.getActionOptions()}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
          />
        </div>
        <div className={'w-full group flex gap-x-5 gap-y-5'}>
          <FormicaSearchSelectBox
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.status', defaultMessage: 'Status' })}
            value={status}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
            rounded
            onChange={(e: FormicaSelectBoxItem) => this.onChangeStatus(e)}
            options={this.getStatusOptions()}
          />
        </div>
        <div className={'h-full flex justify-center items-center'}>
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            icon={'add'}
            customSize={'sm'}
            customType={'primary'}
            onClick={this.addAction}
            disabled={!RoleHelper.canEdit('CaseConfiguration')}
          />
        </div>
      </div>
    );
  }

  private onChangeName = (e: FormicaSelectBoxItem) => {
    this.setState({ name: e.value });
  };

  private onChangeStatus = (e: FormicaSelectBoxItem) => {
    this.setState({ status: e.value });
  };

  private addAction = () => {
    const { name, status } = this.state;
    const {
      configuration: { configuration },
      changeDomain,
    } = this.props;

    if (!name || name.length === 0) {
      return MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'common.label.action', defaultMessage: 'Action' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.actionDetailName', defaultMessage: 'Action name cannot be empty' })}</div>,
      });
    } else if (!status || (status as string).length === 0) {
      return MessageUtil.warning({
        summary: LanguageUtil.get({ id: 'common.label.action', defaultMessage: 'Action' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.actionDetailStatus', defaultMessage: 'Action status cannot be empty' })}</div>,
      });
    } else {
      const actions = configuration.actions || [];
      const existing = actions.find((a: CaseAction) => a.name === name);
      const normalizedStatus = (status as CaseActionStatus) || CaseActionStatus.ALL;
      if (existing) {
        existing.status = normalizedStatus;
      } else {
        const action: CaseAction = {
          name,
          status: normalizedStatus,
        };
        actions.push(action);
      }
      configuration.actions = actions;
      changeDomain(configuration);
      this.setState({ name: undefined, status: undefined });
      return MessageUtil.success({
        summary: LanguageUtil.get({ id: 'common.label.action', defaultMessage: 'Action' }),
        detail: <div>{LanguageUtil.get({ id: 'pages.configuration.panel.actionCreated', defaultMessage: 'Action created.' })}</div>,
      });
    }
  };

  private getActionOptions = () => {
    const {
      configuration: { configuration, actions },
    } = this.props;
    if (!configuration.dataSource) return [];
    return actions
      .filter((a) => a.transaction === configuration.dataSource)
      .map((value) => ({
        label: value.id!,
        value: value.id!,
      }));
  };

  private getStatusOptions = (): FormicaSelectBoxItem[] => {
    return [
      {
        label: LanguageUtil.get({ id: 'common.label.all', defaultMessage: 'All' }),
        value: CaseActionStatus.ALL,
      },
      {
        label: LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' }),
        value: CaseActionStatus.FRAUD,
      },
      {
        label: LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' }),
        value: CaseActionStatus.NOT_FRAUD,
      },
    ];
  };
}

class State {
  name: string | undefined;
  status: CaseActionStatus | undefined;
}

interface Props extends ReduxProps {
  domainConfiguration: CaseSettings;
  changeDomain: (domain: CaseSettings) => void;
}

const mapStateToProps = (state: RootState) => ({
  configuration: state.configuration as ConfigurationState,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationActionCreatorComponent);

